import React, { useState, useRef, useEffect } from 'react';
import StylesMenu from '../ui/StylesMenu';
import MediumButton from '../ui/MediumButton';
import ToggleButton from '../ui/ToggleButton';
import SearchBar from '../ui/SearchBar';
import { SearchIcon, FilterIcon, SortIcon, ThumbsUpIcon, ChevronDownIcon } from '../../utils/icons';
import colors from '../../utils/colors';
import typography from '../../utils/typography';

const StylesIcon = ({ active = false }) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="flex-grow-0 flex-shrink-0 w-4 h-4 relative"
  >
    <path
      d="M8 1C8.39782 1 8.77936 1.15804 9.06066 1.43934C9.34196 1.72064 9.5 2.10218 9.5 2.5V3.5H11.5C11.8978 3.5 12.2794 3.65804 12.5607 3.93934C12.842 4.22064 13 4.60218 13 5V13C13 13.3978 12.842 13.7794 12.5607 14.0607C12.2794 14.342 11.8978 14.5 11.5 14.5H4.5C4.10218 14.5 3.72064 14.342 3.43934 14.0607C3.15804 13.7794 3 13.3978 3 13V5C3 4.60218 3.15804 4.22064 3.43934 3.93934C3.72064 3.65804 4.10218 3.5 4.5 3.5H6.5V2.5C6.5 2.10218 6.65804 1.72064 6.93934 1.43934C7.22064 1.15804 7.60218 1 8 1ZM8 5C7.20435 5 6.44129 5.31607 5.87868 5.87868C5.31607 6.44129 5 7.20435 5 8C5 8.79565 5.31607 9.55871 5.87868 10.1213C6.44129 10.6839 7.20435 11 8 11C8.79565 11 9.55871 10.6839 10.1213 10.1213C10.6839 9.55871 11 8.79565 11 8C11 7.20435 10.6839 6.44129 10.1213 5.87868C9.55871 5.31607 8.79565 5 8 5Z"
      fill={active ? "#0E0808" : "#FAF7F5"}
    />
  </svg>
);

const ClockIcon = ({ active = false }) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="flex-grow-0 flex-shrink-0 w-4 h-4 relative"
  >
    <path
      d="M8 1C11.866 1 15 4.134 15 8C15 11.866 11.866 15 8 15C4.134 15 1 11.866 1 8C1 4.134 4.134 1 8 1ZM8 3C6.67392 3 5.40215 3.52678 4.46447 4.46447C3.52678 5.40215 3 6.67392 3 8C3 9.32608 3.52678 10.5979 4.46447 11.5355C5.40215 12.4732 6.67392 13 8 13C9.32608 13 10.5979 12.4732 11.5355 11.5355C12.4732 10.5979 13 9.32608 13 8C13 6.67392 12.4732 5.40215 11.5355 4.46447C10.5979 3.52678 9.32608 3 8 3ZM8 4C8.26522 4 8.51957 4.10536 8.70711 4.29289C8.89464 4.48043 9 4.73478 9 5V8C9 8.26522 8.89464 8.51957 8.70711 8.70711C8.51957 8.89464 8.26522 9 8 9H6C5.73478 9 5.48043 8.89464 5.29289 8.70711C5.10536 8.51957 5 8.26522 5 8C5 7.73478 5.10536 7.48043 5.29289 7.29289C5.48043 7.10536 5.73478 7 6 7H7V5C7 4.73478 7.10536 4.48043 7.29289 4.29289C7.48043 4.10536 7.73478 4 8 4Z"
      fill={active ? "#0E0808" : "#FAF7F5"}
    />
  </svg>
);

const MoreIcon = () => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="flex-grow-0 flex-shrink-0 w-4 h-4 relative"
  >
    <path
      d="M4 8.5C4.55228 8.5 5 8.05228 5 7.5C5 6.94772 4.55228 6.5 4 6.5C3.44772 6.5 3 6.94772 3 7.5C3 8.05228 3.44772 8.5 4 8.5ZM8 8.5C8.55228 8.5 9 8.05228 9 7.5C9 6.94772 8.55228 6.5 8 6.5C7.44772 6.5 7 6.94772 7 7.5C7 8.05228 7.44772 8.5 8 8.5ZM12 8.5C12.5523 8.5 13 8.05228 13 7.5C13 6.94772 12.5523 6.5 12 6.5C11.4477 6.5 11 6.94772 11 7.5C11 8.05228 11.4477 8.5 12 8.5Z"
      fill="#FAF7F5"
    />
  </svg>
);

const LikedIcon = ({ active = false }) => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="flex-grow-0 flex-shrink-0 w-4 h-4 relative"
  >
    <path
      d="M12.5873 5.52527C12.8751 5.52527 13.127 5.63514 13.3429 5.85487C13.5587 6.07461 13.6667 6.33097 13.6667 6.62395V7.72262C13.6667 7.78671 13.6599 7.85538 13.6464 7.92863C13.6329 8.00187 13.6127 8.07054 13.5857 8.13463L11.9667 12.0075C11.8857 12.1906 11.7508 12.3462 11.5619 12.4744C11.373 12.6026 11.1751 12.6667 10.9683 12.6667H6.6508C6.35397 12.6667 6.09987 12.5591 5.88849 12.3439C5.67712 12.1288 5.57143 11.8701 5.57143 11.568V5.97848C5.57143 5.83199 5.60066 5.69236 5.65913 5.55961C5.7176 5.42685 5.7963 5.31011 5.89524 5.2094L8.82302 2.24298C8.95794 2.1148 9.1176 2.03697 9.30199 2.00951C9.48638 1.98204 9.66402 2.01409 9.83492 2.10564C10.0058 2.1972 10.1295 2.32538 10.206 2.49018C10.2824 2.65498 10.2982 2.82436 10.2532 2.99832L9.64603 5.52527H12.5873ZM3.4127 12.6667C3.11588 12.6667 2.86178 12.5591 2.6504 12.3439C2.43902 12.1288 2.33334 11.8701 2.33334 11.568V6.62395C2.33334 6.32181 2.43902 6.06317 2.6504 5.84801C2.86178 5.63285 3.11588 5.52527 3.4127 5.52527C3.70953 5.52527 3.96363 5.63285 4.175 5.84801C4.38638 6.06317 4.49207 6.32181 4.49207 6.62395V11.568C4.49207 11.8701 4.38638 12.1288 4.175 12.3439C3.96363 12.5591 3.70953 12.6667 3.4127 12.6667Z"
      fill={active ? "#0E0808" : "#FAF7F5"}
    />
  </svg>
);

const ViewListIcon = () => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className="flex-grow-0 flex-shrink-0 w-4 h-4 relative"
  >
    <path
      d="M6.66667 12.667C6.29848 12.667 6 12.3685 6 12.0003C6 11.6321 6.29848 11.3337 6.66667 11.3337H13.3333C13.7015 11.3337 14 11.6321 14 12.0003C14 12.3685 13.7015 12.667 13.3333 12.667H6.66667ZM6.66667 8.66699C6.29848 8.66699 6 8.36851 6 8.00033C6 7.63214 6.29848 7.33366 6.66667 7.33366H13.3333C13.7015 7.33366 14 7.63214 14 8.00033C14 8.36851 13.7015 8.66699 13.3333 8.66699H6.66667ZM6.66667 4.66699C6.29848 4.66699 6 4.36852 6 4.00033C6 3.63214 6.29848 3.33366 6.66667 3.33366H13.3333C13.7015 3.33366 14 3.63214 14 4.00033C14 4.36852 13.7015 4.66699 13.3333 4.66699H6.66667ZM3.33333 13.3337C2.96667 13.3337 2.65278 13.2031 2.39167 12.942C2.13056 12.6809 2 12.367 2 12.0003C2 11.6337 2.13056 11.3198 2.39167 11.0587C2.65278 10.7975 2.96667 10.667 3.33333 10.667C3.7 10.667 4.01389 10.7975 4.275 11.0587C4.53611 11.3198 4.66667 11.6337 4.66667 12.0003C4.66667 12.367 4.53611 12.6809 4.275 12.942C4.01389 13.2031 3.7 13.3337 3.33333 13.3337ZM3.33333 9.33366C2.96667 9.33366 2.65278 9.2031 2.39167 8.94199C2.13056 8.68088 2 8.36699 2 8.00033C2 7.63366 2.13056 7.31977 2.39167 7.05866C2.65278 6.79755 2.96667 6.66699 3.33333 6.66699C3.7 6.66699 4.01389 6.79755 4.275 7.05866C4.53611 7.31977 4.66667 7.63366 4.66667 8.00033C4.66667 8.36699 4.53611 8.68088 4.275 8.94199C4.01389 9.2031 3.7 9.33366 3.33333 9.33366ZM3.33333 5.33366C2.96667 5.33366 2.65278 5.2031 2.39167 4.94199C2.13056 4.68088 2 4.36699 2 4.00033C2 3.63366 2.13056 3.31977 2.39167 3.05866C2.65278 2.79755 2.96667 2.66699 3.33333 2.66699C3.7 2.66699 4.01389 2.79755 4.275 3.05866C4.53611 3.31977 4.66667 3.63366 4.66667 4.00033C4.66667 4.36699 4.53611 4.68088 4.275 4.94199C4.01389 5.2031 3.7 5.33366 3.33333 5.33366Z"
      fill="#FAF7F5"
    />
  </svg>
);

const FilterButton = ({ 
  label, 
  icon, 
  hasDropdown = false, 
  showCount = false, 
  count = 0, 
  onClick, 
  active = false, 
  className = "",
  iconOnly = false,
  textOnlyWhenExpanded = false
}) => {
  // Handle special case for textOnlyWhenExpanded
  const shouldShowIcon = icon && (!textOnlyWhenExpanded || iconOnly);
  const shouldShowText = !iconOnly && (!textOnlyWhenExpanded || !iconOnly);

  return (
    <div 
      className={`flex justify-center items-center gap-1 h-10 rounded-[100px] cursor-pointer transition-colors ${iconOnly ? 'px-4' : 'px-4'} ${className}`}
      style={{
        backgroundColor: active ? colors.text.primary : colors.bg.tertiary,
      }}
      onMouseEnter={(e) => !active && (e.target.style.backgroundColor = colors.bg.glass.thick)}
      onMouseLeave={(e) => !active && (e.target.style.backgroundColor = colors.bg.tertiary)}
      onClick={onClick}
    >
      <div className="flex justify-start items-center flex-grow-0 flex-shrink-0 relative gap-0.5">
        {/* Show icon conditionally based on textOnlyWhenExpanded logic */}
        {shouldShowIcon && icon}
        {shouldShowText && (
          <p className="flex-grow-0 flex-shrink-0 text-sm font-medium text-center"
             style={{ color: active ? colors.bg.primary : colors.text.primary }}>
            {label}
            {showCount && count > 0 && ` (${count})`}
          </p>
        )}
        {/* Show count even in icon-only state for Filters button */}
        {iconOnly && showCount && count > 0 && (
          <p className="flex-grow-0 flex-shrink-0 text-sm font-medium text-center"
             style={{ color: active ? colors.bg.primary : colors.text.primary }}>
            ({count})
          </p>
        )}
        {hasDropdown && <ChevronDownIcon active={active} />}
      </div>
    </div>
  );
};

const FilterNav = ({ 
  activeFilters = [],
  searchValue = "",
  onFilterClick,
  onSearchChange,
  onSortChange,
  filterCount = 0,
  sidePanelOpen = false,
  hideStyles = false,
  currentSort = 'newest',
  availableStyles = [],
  selectedStyles = [],
  onStyleToggle,
  styleCounts = {},
  currentView = 'list',
  onViewChange
}) => {
  const [searchInput, setSearchInput] = useState(searchValue);
  const [showStylesMenu, setShowStylesMenu] = useState(false);
  const stylesButtonRef = useRef(null);
  const stylesMenuRef = useRef(null);

  const handleSearchChange = (e) => {
    const value = e.target.value;
    setSearchInput(value);
    onSearchChange?.(value);
  };

  const handleSortChange = (sortId) => {
    onSortChange?.(sortId);
  };

  const handleFilterMultiChange = (selectedFilterValues) => {
    // For each filter value, toggle it in the activeFilters
    selectedFilterValues.forEach(filterId => {
      if (!activeFilters.includes(filterId)) {
        onFilterClick?.(filterId);
      }
    });
    
    // Remove any filters that were deselected
    activeFilters.forEach(filterId => {
      if (!selectedFilterValues.includes(filterId) && filterId !== 'filters') {
        onFilterClick?.(filterId);
      }
    });
  };

  const handleStylesClick = () => {
    setShowStylesMenu(!showStylesMenu);
  };

  const handleStyleToggle = (style) => {
    onStyleToggle?.(style);
    // Don't close the menu on style toggle - let users select multiple styles
  };

  const handleViewChange = (viewId) => {
    onViewChange?.(viewId);
  };


  // Handle click outside to close styles menu
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (stylesMenuRef.current && !stylesMenuRef.current.contains(event.target) &&
          stylesButtonRef.current && !stylesButtonRef.current.contains(event.target)) {
        setShowStylesMenu(false);
      }
    };

    if (showStylesMenu) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => document.removeEventListener('mousedown', handleClickOutside);
    }
  }, [showStylesMenu]);


  // Get display label for current sort
  const getSortLabel = () => {
    const sortLabels = {
      'newest': 'Newest',
      'oldest': 'Oldest',
      'alphabetical': 'A→Z',
      'duration-longest': 'Duration: Longest',
      'duration-shortest': 'Duration: Shortest',
      'play-count': 'Play Count',
      'comment-count': 'Comment Count',
      'like-count': 'Like Count'
    };
    return sortLabels[currentSort] || 'Newest';
  };

  // Create dropdown options for sort
  const sortDropdownOptions = [
    { value: 'newest', label: 'Newest' },
    { value: 'oldest', label: 'Oldest' },
    { value: 'alphabetical', label: 'A→Z' },
    { value: 'duration-longest', label: 'Duration: Longest' },
    { value: 'duration-shortest', label: 'Duration: Shortest' },
    { value: 'play-count', label: 'Play Count' },
    { value: 'comment-count', label: 'Comment Count' },
    { value: 'like-count', label: 'Like Count' }
  ];

  // Create dropdown options for filters
  const filterDropdownOptions = [
    { value: 'liked', label: 'Liked' },
    { value: 'public', label: 'Public' },
    { value: 'uploads', label: 'Uploads' },
    { value: 'published', label: 'Published' },
    { value: 'full-songs', label: 'Full Songs' },
    { value: 'covers', label: 'Covers' },
    { value: 'personas', label: 'Personas' },
    { value: 'hide-disliked', label: 'Hide Disliked' },
    { value: 'hide-stems', label: 'Hide Stems' }
  ];

  // Create dropdown options for view
  const viewDropdownOptions = [
    { value: 'list', label: 'List' },
    { value: 'compact', label: 'Compact' }
  ];

  const filterButtons = [
    { 
      id: 'filters', 
      label: 'Filters', 
      icon: <FilterIcon active={activeFilters.includes('filters')} />,
      hasDropdown: true, 
      showCount: true, 
      count: filterCount,
      isFilter: true // Special flag to identify filter button
    },
    { 
      id: 'sort', 
      label: getSortLabel(), 
      icon: <SortIcon active={false} />, // Never show as active/white
      hasDropdown: true,
      isSort: true // Special flag to identify sort button
    },
    { 
      id: 'styles', 
      label: 'Styles',
      icon: null,
      hasDropdown: true,
      hidden: hideStyles,
      isStyles: true // Special flag to identify styles button
    },
    { 
      id: 'liked', 
      label: 'Liked',
      icon: <LikedIcon active={activeFilters.includes('liked')} />
    },
    { 
      id: 'public', 
      label: 'Public',
      icon: null
    },
    { 
      id: 'uploads', 
      label: 'Uploads',
      icon: null
    }
  ];

  return (
    <div className="flex items-center gap-2 w-full" style={{ paddingRight: sidePanelOpen ? '24px' : '0px' }}>
      {/* Search Bar */}
      <div className="flex-1 min-w-0" style={{ minWidth: sidePanelOpen ? '100px' : '0px', maxWidth: sidePanelOpen ? 'calc(100% - 400px)' : '100%' }}>
        <div className="flex items-center gap-2 px-3 rounded-full border" style={{ backgroundColor: colors.bg.fog.thin, borderColor: colors.bg.secondary, height: '40px' }}>
          <div className="flex items-center justify-center flex-shrink-0" style={{ color: colors.text.inactive, width: '16px', height: '16px' }}>
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.94453 11.8891C5.5626 11.8891 4.39303 11.4105 3.43582 10.4532C2.47861 9.49604 2 8.32647 2 6.94453C2 5.5626 2.47861 4.39303 3.43582 3.43582C4.39303 2.47861 5.5626 2 6.94453 2C8.32647 2 9.49604 2.47861 10.4532 3.43582C11.4105 4.39303 11.8891 5.5626 11.8891 6.94453C11.8891 7.50238 11.8003 8.02853 11.6228 8.52298C11.4453 9.01743 11.2044 9.45483 10.9002 9.83518L13.7908 12.7258C13.9303 12.8653 14 13.0428 14 13.2583C14 13.4739 13.9303 13.6513 13.7908 13.7908C13.6513 13.9303 13.4739 14 13.2583 14C13.0428 14 12.8653 13.9303 12.7258 13.7908L9.83518 10.9002C9.45483 11.2044 9.01743 11.4453 8.52298 11.6228C8.02853 11.8003 7.50238 11.8891 6.94453 11.8891ZM6.94453 10.3677C7.8954 10.3677 8.70365 10.0349 9.36926 9.36926C10.0349 8.70365 10.3677 7.8954 10.3677 6.94453C10.3677 5.99366 10.0349 5.18542 9.36926 4.51981C8.70365 3.8542 7.8954 3.52139 6.94453 3.52139C5.99366 3.52139 5.18542 3.8542 4.51981 4.51981C3.8542 5.18542 3.52139 5.99366 3.52139 6.94453C3.52139 7.8954 3.8542 8.70365 4.51981 9.36926C5.18542 10.0349 5.99366 10.3677 6.94453 10.3677Z" fill="currentColor"/>
            </svg>
          </div>
          <input
            type="text"
            placeholder="Search for a song"
            value={searchInput}
            onChange={(e) => {
              setSearchInput(e.target.value);
              onSearchChange?.(e.target.value);
            }}
            className="flex-1 bg-transparent border-none outline-none text-sm placeholder:text-[var(--placeholder-color)]"
            style={{
              color: colors.text.primary,
              ...typography.small.title,
              '--placeholder-color': colors.bg.fog.dense
            }}
          />
        </div>
      </div>

      {/* Filter Button */}
      <MediumButton
        variant="secondary"
        leftIcon={<FilterIcon />}
        dropdownOptions={filterDropdownOptions}
        dropdownValues={activeFilters.filter(filter => filter !== 'filters')}
        onDropdownMultiChange={handleFilterMultiChange}
        isMultiSelect={true}
        dropdownPosition="bottom-left"
        dropdownWidth={180}
        showDropdownIcon={false}
      />

      {/* Sort Button */}
      <MediumButton
        variant="secondary"
        leftIcon={<SortIcon />}
        dropdownOptions={sortDropdownOptions}
        dropdownValue={currentSort}
        onDropdownChange={(value) => onSortChange?.(value)}
        dropdownPosition="bottom-left"
        dropdownWidth={200}
        showDropdownIcon={false}
      />

      {/* Liked Button */}
      <MediumButton
        variant={activeFilters.includes('liked') ? 'primary' : 'tertiary'}
        leftIcon={<ThumbsUpIcon />}
        onClick={() => onFilterClick?.('liked')}
      />
    </div>
  );
};

export default FilterNav;
